import React from 'react';
import { useState, useEffect } from 'react';
import Resizer from 'react-image-file-resizer';
import Axios from 'axios';
import './styles/profiles.css'

const Me = (props) => {
    const [myProfile, setMyProfile] = useState(props.myProfile);
    const [userID, setUserID] = useState(props.userID);
    const [message, setmessage] = useState('');
    const [showEditBio, setShowEditBIo] = useState(false);
    const [bioContent, setBioContent] = useState(props.myProfile.about);
    const [siteInfo, setSiteInfo] = useState(false);
    useEffect(() => {
        setMyProfile(props.myProfile);
        setBioContent(props.myProfile.about);
    }, [props.myProfile]);

    const posUploadHandler = (event) => {
        setmessage('Uploading....')

        var fileInput = false
        if (event.target.files[0]) {
            fileInput = true
        }

        if (fileInput) {
            // var userId = Cookie.get('userId');
            // var password = Cookie.get('password');
            Resizer.imageFileResizer(
                event.target.files[0],
                196,
                257,
                'JPEG',
                80, //quality
                0,//rotation
                uri => {//////////////////////////////uploading profilepic
                    // console.log(uri)

                    Axios.post('https://conffesion.herokuapp.com/updateProfilePic', { uploadImage: uri, userID: userID })
                        .then(res => {

                            setmessage('Done! refresh to see.')
                        })
                        .catch(err => { setmessage(err.message) })
                },
                'base64'
            );
        }
    }
    const uploadBio = () => {
        setmessage('Updating....')
        Axios.post('https://conffesion.herokuapp.com/editBio', { bioContent: bioContent, userID: userID })
            .then(res => {
                setmessage('Done! refresh to see.');
            })
            .catch(err => { setmessage(err.message) })
    }
    return (
        <div className="container" key={myProfile._id}>
            <p>{message}</p>
            <div className="row profile">
                <div className="col-md-3">
                    <div className="profile-sidebar">

                        <div className="profile-userpic pp">
                            <img src={myProfile.imageString} className="img-responsive immm" alt="" />
                            <div className='updateProfile'><span className="updateIcon" onClick={() => { document.getElementById("imageInput_post").click() }}></span></div>
                        </div>
                        <div className="profile-usertitle">
                            <div className="profile-usertitle-name">
                                {myProfile.name}
                            </div>
                            <div className="profile-usertitle-job">
                                <p>  {myProfile.about}<span className='pencil' onClick={() => { setShowEditBIo(!showEditBio) }}></span></p>
                            </div>
                            {showEditBio ? (
                                <div className='bioEditDiv'>
                                    <div className="form__group field">
                                        <input type="input" className="form__field" placeholder="Reply" name="reply" id='name' value={bioContent} onChange={(e) => { setBioContent(e.target.value) }} />
                                        <label className="form__label">edit bio</label>
                                        <button className='btn btn-default' style={{ position: 'relative', float: 'right' }} onClick={() => { uploadBio() }}>update</button>
                                        <button className="btn btn-default" onClick={() => { setShowEditBIo(false) }}>nah</button>
                                    </div>

                                </div>
                            ) : (
                                    <p></p>
                                )}

                        </div>
                        <div className="profile-userbuttons">
                            <button type="button" className="btn btn-outline-success btn-sm" disabled>{myProfile.followers.length + " followers"}</button>
                            {/* <button type="button" className="btn btn-danger btn-sm">Message</button> */}

                        </div>

                    </div>
                </div>
                {/* <div className='btn btn-primary' disabled={profileUploadDisable} onClick={() => { }}>Set profile picture</div> */}
                <input type="file" name="filetoupload" id="imageInput_post" accept="image/*" hidden onChange={(e) => posUploadHandler(e)}></input>
            </div>
            <button className='btn btn-link' onClick={() => { setSiteInfo(!siteInfo) }}><p style={{ fontSize: 'x-small' }}>{siteInfo ? "Close" : "info"}</p></button>
            {siteInfo ? (
                <p style={{ fontSize: 'xx-small' }}>
                    Hi,Thank you so much for joining.
                    You are completly anonyomous here while posting to someone.
                    We do not collect any info about the person who posted.
                    So you are completly free to post.
                    For further info you can contact me through <a href="https://www.instagram.com/rupamj_das/">Instagram</a>
                    ----Rupam Jyoti Das &#x1F642;
                </p>
            ) : (<p></p>)}
        </div>
    )
}
export default Me;